import React, { useState, useEffect } from "react";
import Layout from "../../layouts";
import { toast } from "react-toastify";
import DynamicTable from "../../components/DynamicTable";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../utils/apiClient";
import apiService from "../../services/apiService";

interface PromoCode {
  promo_code_name: string;
  discound_percentage: number;
  usage_limit: number;
  uses_available: number;
  uses_completed: number;
  applicable_ticket_types: string;
  event_name: string;
  event_id: number;
}

export default function EventPromoCodes() {
  const [promoCodes, setPromoCodes] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const queryEventId = new URLSearchParams(location.search).get("eventId");

  const [eventId, setEventId] = useState<any>(queryEventId);

  const columns: any = [
    { key: "promoCodeName", label: "Promo Code" },
    { key: "discountPercentage", label: "Discount (%)" },
    { key: "usageLimit", label: "Usage Limit" },
    { key: "usesAvailable", label: "Available Uses" },
    { key: "usesCompleted", label: "Completed Uses" },
    { key: "applicableTicketTypes", label: "Ticket Types" },
     { key: "eventId", label: "Event Id" },
    { key: "eventName", label: "Event Name" },
    {
      key: "actions",
      label: "Actions",
      className:
        "px-4 py-3 whitespace-nowrap text-right sticky right-0 z-10 rounded space-x-2 bg-white/30 backdrop-blur-md shadow-md",
      render: (_: any, row: any) => (
        <button
          onClick={() => {
            navigator.clipboard.writeText(row.promoCodeName);
            toast.success("Promo code copied!");
          }}
          className="px-2 py-1 text-xs bg-indigo-500 text-white rounded hover:bg-indigo-600 transition"
        >
          Copy Code
        </button>
      ),
    },
  ];

  useEffect(() => {
    fetchPromoCodes(eventId, page, search);
  }, [eventId, page, search]);

  const fetchPromoCodes = async (
    eventId?: number,
    activePageNo?: number,
    searchTerm?: any
  ) => {
    try {
      setLoading(true);

      // Build params conditionally
      const params: any = {
        page: activePageNo,
        limit: 50,
        search: searchTerm,
        ...(eventId ? { eventId } : {}), // ✅ adds eventId only if it exists
      };

      const response: any = await apiService.get(
        "/event/get-promo-codes",
        params
      );
      setPromoCodes(response?.data?.data || []); // ✅ updated: response.data is now event array
      setTotalRecords(response?.data?.totalCount || 0);
      setTotalPages(response?.data?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching events:", error);
      toast.error("Failed to fetch events");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (searchKey?: string) => {
    console.log("Searching for Event ID:", searchKey);

    const params = new URLSearchParams(location.search);

    if (searchKey && searchKey.trim() !== "") {
      // ✅ Add/replace eventId
      params.set("eventId", searchKey.trim());
    } else {
      // ❌ searchKey empty → remove eventId
      params.delete("eventId");
    }

    // 🚀 Update URL (no reload)
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });

    // ✅ Update local state if needed
    setEventId(searchKey || "");
    setPage(1);
  };

  return (
    <Layout
      pageTitle="Promo Codes"
      eventId={eventId}
      searchByEventId={{
        label: "Search by Event ID",
        onClick: (val?: any) => {
          handleSearch(val);
        }, // 👈 your custom handler
        className: "bg-green-600 hover:bg-green-700",
      }}
    >
      <div className="min-h-screen bg-gray-50 py-2 px-4">
        <DynamicTable
          title="Promo Codes"
          data={promoCodes}
          columns={columns}
          pageSize={50}
          loading={loading}
          activeNUmber={page}
          onPageChange={(newPage) => setPage(newPage)}
          totalPages={totalPages}
          totalRecords={totalRecords}
          // onSearch={(val?: any) => {
          //   setPage(1);
          //   setSearch(val);
          // }}
        />
      </div>
    </Layout>
  );
}
